/// <amd-module name="SuiteCommerce.GridOrder.Row.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.GridOrder.Row.Model", ["require", "exports", "SuiteCommerce.GridOrder.Common.DependencyProvider", "Backbone", "SuiteCommerce.GridOrder.Cell.Model", "SuiteCommerce.GridOrder.MatrixChildItem.Model"], function (require, exports, DependencyProvider_1, Backbone_1, GridOrder_Cell_Model_1, GridOrder_Cell_MatrixChildItem_Model_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var RowModel = /** @class */ (function (_super) {
        __extends(RowModel, _super);
        function RowModel() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(RowModel.prototype, "cellsCollection", {
            get: function () {
                return this.get('cellsCollection');
            },
            enumerable: true,
            configurable: true
        });
        RowModel.prototype.hasPricesSchedules = function () {
            if (DependencyProvider_1.ProfileModel.getInstance().hidePrices()) {
                return false;
            }
            var pricesSchedulesModels = this.cellsCollection.filter(function (cell) {
                return !!(GridOrder_Cell_Model_1.isInstanceOf(cell, GridOrder_Cell_MatrixChildItem_Model_1.MatrixChildItemModel)
                    && cell.onlineCustomerPriceDetails
                    && cell.onlineCustomerPriceDetails.priceschedule);
            });
            return pricesSchedulesModels.length > 0;
        };
        RowModel.prototype.getPricesSchedules = function () {
            var pricesByChildItem = [];
            this.cellsCollection.each(function (cell) {
                if (GridOrder_Cell_Model_1.isInstanceOf(cell, GridOrder_Cell_MatrixChildItem_Model_1.MatrixChildItemModel)) {
                    var matrixChildItemInternalId = cell.internalId;
                    var onlineCustomerPrice = cell.onlineCustomerPriceDetails;
                    var pricesSchedule = onlineCustomerPrice && onlineCustomerPrice.priceschedule;
                    if (pricesSchedule) {
                        pricesByChildItem.push({
                            pricesSchedule: pricesSchedule,
                            internalId: matrixChildItemInternalId,
                        });
                    }
                    else {
                        pricesByChildItem.push({ optionNotAvailable: true });
                    }
                }
            });
            return pricesByChildItem;
        };
        return RowModel;
    }(Backbone_1.Model));
    exports.RowModel = RowModel;
});
